<template>
  <page>
    <span slot="page-title">Email Verified</span>
    <p>Thanks for verifying your email address.</p>
    <p>You will be redirected to the home page in {{ seconds }} seconds.  <a href="/" @click="goHome($event)">Click here</a> to go there now.</p>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { Page } from '@/components'

const name = 'email_verified'

const computed = {
  ...mapGetters({
    elections: 'elections/list'
  })
}

const methods = {
  goHome ($event) {
    if ($event) {
      $event.preventDefault()
    }
    this.$router.replace({ name: 'home' })
  }
}

const components = {
  Page
}

export default {
  name,
  computed,
  methods,
  components,
  metaInfo: {
    title: 'Email Verified'
  },
  data () {
    return {
      seconds: 4
    }
  },
  mounted () {
    let interval = setInterval(() => {
      if (this.elections.length > 0) {
        clearInterval(interval)
        interval = setInterval(() => {
          this.seconds -= 1
          if (this.seconds === 0) {
            this.goHome()
            clearInterval(interval)
          }
        }, 1000)
      }
    }, 200)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EmailVerified.vue